import React from "react";

function SelectFormControl({
  label,
  id,
  name,
  value,
  options,
  optionLabelField,
  optionValueField,
  selectAll,
  selectAllText,
  onChange,
  error,
  ...rest
}) {
  return (
    <div className="form-group">
      <label for={id} className="font-weight-bold">
        {label}
        {rest.required && <span className="text-danger mx-1">*</span>}
      </label>
      <select
        id={id}
        name={name}
        className={`form-control custom-select custom-select-sm ${
          error && "is-invalid"
        }`}
        // className="custom-select custom-select-sm"
        value={value || ""}
        onChange={onChange}
        {...rest}
      >
        {selectAll && <option value="">{selectAllText || "All"}</option>}
        {options &&
          options.length > 0 &&
          options.map((op, i) => (
            <option value={op[optionValueField]} key={i}>
              {op[optionLabelField]}
            </option>
          ))}
      </select>
      {(error || error?.message) && (
        <div id="Feedback" class="invalid-feedback">
          {error?.message || (typeof error === "string" && error)}
        </div>
      )}
    </div>
  );
}

export default SelectFormControl;
